// extracted by mini-css-extract-plugin
export var active = "_a9-7";
export var container = "_a9-0";
export var evenWidth = "_a9-4";
export var large = "_a9-5";
export var outlet = "_a9-8";
export var slide = "_a9-2";
export var small = "_a9-6";
export var tab = "_a9-3";
export var tabs = "_a9-1";